import React from 'react';

export default function Stripes(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={124.417}
            height={195.739}
            style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            }}
            viewBox="0 0 1696 2668"
            className={props.className}
        >
            <defs>
                <style>
                    {`
                        #c-${props.id} .fil2 {fill:#${props.stripesColors}}
                        #c-${props.id} .fil0 {fill:#${props.base};fill-rule:nonzero}
                        #c-${props.id} .fil1 {fill:#252422;fill-rule:nonzero}
                    `}
                </style>
            </defs>
            <g id={`c-${props.id}`}>
                <path className="fil0" d="M86 2540c105,13 434,49 758,49 420,0 684,-34 772,-47l0 -1691c-34,-42 -139,-186 -151,-383 -10,-160 11,-257 22,-305 -58,-20 -162,-53 -266,-73 -38,231 -196,397 -390,397 -195,0 -346,-158 -386,-393 -60,14 -115,33 -157,48 -20,7 -37,13 -52,18 -28,8 -43,13 -79,28 28,131 44,222 37,326 -13,177 -90,302 -116,339l6 1688zm1047 -2417c-62,34 -164,72 -312,66 -133,-5 -229,-39 -288,-69 42,173 156,286 299,286 141,0 258,-116 302,-284z"/>
                <path className="fil1" d="M86 2540c105,13 434,49 758,49 420,0 684,-34 772,-47l0 -1691c-34,-42 -139,-186 -151,-383 -10,-160 11,-257 22,-305 -58,-20 -162,-53 -266,-73 -38,231 -196,397 -390,397 -195,0 -346,-158 -386,-393 -60,14 -115,33 -157,48 -20,7 -37,13 -52,18 -28,8 -43,13 -79,28 28,131 44,222 37,326 -13,177 -90,302 -116,339l6 1688zm1047 -2417c-62,34 -164,72 -312,66 -133,-5 -229,-39 -288,-69 42,173 156,286 299,286 141,0 258,-116 302,-284zm-696 -109l0 -3 22 -1c7,-1 15,-3 22,-4l19 -3 5 4 12 -1c0,4 0,8 1,12 20,15 121,85 307,92 224,8 321,-91 325,-95l1 -2c0,-2 0,-4 0,-6l6 0 7 -7 20 2c145,19 299,73 357,93l3 1c38,13 29,52 23,81 -10,43 -30,133 -21,285 12,202 139,345 141,347l10 11 0 15 0 1773 -32 6c-12,2 -289,54 -819,54 -397,0 -799,-53 -803,-54l-35 -5 -7 -1785 9 -11c1,-1 95,-123 108,-307 7,-102 -10,-190 -42,-336l-7 -32 30 -13c63,-27 82,-33 117,-44 13,-4 30,-10 48,-16 46,-16 106,-38 174,-52z"/>
                <g>
                    <path className="fil2" d="M714 466l0 2121c-145,-4 -285,-13 -398,-23l0 -2431c37,-13 81,-27 130,-38 32,185 132,323 268,373z"/>
                    <path className="fil2" d="M1380 128l0 2440c-104,9 -237,16 -398,19l0 -2136c122,-61 212,-194 240,-362 55,10 110,24 158,38z"/>
                </g>
            </g>
        </svg>
    );
}
